import {HttpClient} from "../../service/httpClient/HttpClient";
import {convertPersianDateToUniversalDate} from "@moeindal/base-raiko-panel-components";

export class CostAndRevenueService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getCashTransactionsReport(fundID) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/costs-and-revenues/report-status`
            ).then(resolve).catch(reject)
        })
    }

    getCashTransactionsList(
        fundID,
        page,
        size,
        name,
        startDate,
        endDate,
        tagId,
        categoryId,
        filterType
    ) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/costs-and-revenues`,
                {
                    page: page,
                    size: size,
                    title: name,
                    "start-date": convertPersianDateToUniversalDate(startDate),
                    "end-date": convertPersianDateToUniversalDate(endDate),
                    "tag-id": tagId && tagId >= 0 ? tagId : "",
                    "category-id": categoryId && categoryId >= 0 ? categoryId : "",
                    kind: filterType && filterType !== 'ALL' ? filterType : null
                }
            ).then(resolve).catch(reject)
        })
    }

    getCashTransactionDetails(fundID, transactionId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/costs-and-revenues/${transactionId}`
            ).then(resolve).catch(reject)
        })
    }

    updateCashTransactionDetails(
        fundID,
        transactionId,
        title,
        transactionKind,
        amount,
        date,
        tagId,
        enabled,
        description,
        selectedCategoryId) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `funds/${fundID}/costs-and-revenues/${transactionId}`,
                {
                    "title": title,
                    "kind": transactionKind,
                    "amount": amount,
                    "payAt": convertPersianDateToUniversalDate(date),
                    tagId: tagId > 0 ? tagId : "",
                    "enabled": enabled,
                    "description": description,
                    activeCategories: selectedCategoryId && selectedCategoryId !== -1 ? [selectedCategoryId] : []
                }
            ).then(resolve).catch(reject)
        })
    }

    deleteCashTransaction(fundID, transactionId) {
        return new Promise((resolve, reject) => {
            this.httpClient.delete(
                `funds/${fundID}/costs-and-revenues/${transactionId}`
            ).then(resolve).catch(reject)
        })
    }

    addNewCashTransaction(fundID,title,amount, date, transactionKind, enabled, description, tagId, selectedCategoryId) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `funds/${fundID}/costs-and-revenues`,
                {
                    "title": title,
                    "amount": amount,
                    "payAt": convertPersianDateToUniversalDate(date),
                    "kind": transactionKind,
                    "enabled": enabled,
                    "description": description,
                    tagId: tagId > 0 ? tagId : "",
                    activeCategories: selectedCategoryId && selectedCategoryId !== -1 ? [selectedCategoryId] : []
                }
            ).then(resolve).catch(reject)
        })
    }

}